import React, { useEffect, useState } from 'react';
import Logo from '../tools/Logo';
import { Link } from 'react-router-dom';
import { useGetNotificationsQuery } from '../../store/api/notificationApi';
import { useGetUserRolesQuery } from '../../store/api/userAuthApi';


const initialVlaues = {
  isAdmin: false,
  isStoreKeeper: true,
};



const Sidebar = () => {

  let userLogedInId = localStorage.getItem("UserData") != null ? JSON.parse(localStorage.getItem("UserData")).id === null ? 0 : JSON.parse(localStorage.getItem("UserData")).id : 0;

  const userRoles = useGetUserRolesQuery(userLogedInId, { pollingInterval: 10000 }).data;
  var userRolesData = userRoles ?? [];

  userRolesData.map((user) => (
    user.roles.map((role) => {
      if (role.isAdmin === true) {
        initialVlaues.isAdmin = role.isAdmin;
        initialVlaues.isStoreKeeper = false;
      } else if (role.isStoreKeeper === true) {
        initialVlaues.isStoreKeeper = role.isStoreKeeper;
        initialVlaues.isAdmin = false;
      }
      return role;
    })
  ))















  const [notification, setNotifications] = useState([])
  const { data } = useGetNotificationsQuery()

  useEffect(() => {
    if (data) {
      setNotifications(data)
    }
  }, [data])

  const mainWrapper = () => {
    let screenWidth = window.innerWidth
    if (screenWidth <= 991) {
      document.querySelector('.sidebar-o').classList.remove('sidebar-o-xs')
    }
  }

  const lougOut = () => {
    localStorage.removeItem("UserData");
    localStorage.removeItem('orders');
    localStorage.removeItem("materialIssues");
    localStorage.removeItem('materialReturning');
    window.location.reload()
  }

  return (
    <div className="sidebar">
      <nav id="sidebar">
        <div className="sidebar-content">
          <div className="content-header content-header-fullrow px-15">
            <div className="content-header-section text-center align-parent sidebar-mini-hidden">
              <button
                type="button"
                className="btn btn-circle btn-dual-secondary d-lg-none align-v-r"
                data-toggle="layout"
                data-action="sidebar_close"
              >
                <i className="fa fa-times text-danger"></i>
              </button>

              <div className="content-header-item">
                <Logo _width={160} name={'logo.jpg'} />
              </div>
            </div>
          </div>

          <div className="content-side content-side-full content-side-user px-10 align-parent">
            {/* <!-- Visible only in mini mode --> */}
            <div className="sidebar-mini-visible-b align-v animated fadeIn">
            </div>

            <div className="sidebar-mini-hidden-b text-center">
              <Link className="img-link" to={'/'}>
                <i className="fa fa-institution text-dark mb-3 mt-10" style={{ fontSize: 40 }}></i>
              </Link>
              <ul className="list-inline mt-1">
                <li className="list-inline-item">
                  <h4 className="fw-bold ">Stock Management</h4>
                </li>
              </ul>
            </div>
          </div>

          <div className="content-side content-side-full">
            <ul className="nav-main">
              <li>
                <Link className="active text-decoration-none" to="/dashboard" onClick={mainWrapper}>
                  <i className="si si-cup color-text-dark"></i>
                  <span className="sidebar-mini-hide text-d">Dashboard</span>
                </Link>
              </li>

              <li className="nav-main-heading">
                <span className="sidebar-mini-visible">UI</span>
                <span className="sidebar-mini-hidden">User Interface</span>
              </li>

              <li className="mb-2">
                <Link className="bg-light text-decoration-none" to={'/notifications'} onClick={mainWrapper}>
                  <i className="fa fa-bell color-text-dark "></i>
                  <div className={'d-flex justify-content-between align-content-center '}>
                    <span className="sidebar-mini-hide text-decoration-none">Notifications</span>
                    <span className={notification?.length > 0 ? " text-center badge rounded-5 bg-danger" : "d-none"}>{notification?.length}</span>
                  </div>
                </Link>
              </li>
              <li className="mb-2">
                <Link className="bg-light text-decoration-none" to={'/view_stock_movement'} onClick={mainWrapper}>
                  <i className="fa fa-eye color-text-dark"></i>
                  <span className="sidebar-mini-hide text-decoration-none">View Stock Movement</span>
                </Link>
              </li>
              <li className="mb-2">
                <Link className="bg-light text-decoration-none" to={'/requested_products'} onClick={mainWrapper}>
                  <i className="fa fa-eye color-text-dark"></i>
                  <span className="sidebar-mini-hide text-decoration-none">Current Purchased Orders</span>
                </Link>
              </li>
              <li className="mb-2">
                <Link className="bg-light text-decoration-none" to={'/recieved_requested_products'} onClick={mainWrapper}>
                  <i className="fa fa-eye color-text-dark"></i>
                  <span className="sidebar-mini-hide text-decoration-none">All Purchased Orders</span>
                </Link>
              </li>

              <li className="mb-2">
                <Link className="bg-light text-decoration-none" to={'/categories'} onClick={mainWrapper}>
                  <Logo _width={17} name={'/icons/category-01.svg'} _height={17} _marginLeft={-25} />

                  <span className="sidebar-mini-hide text-decoration-none mx-2">Categories</span>
                </Link>
              </li>

              <li className="mb-2">
                <Link className="bg-light text-decoration-none" to={'/units'} onClick={mainWrapper}>
                  <Logo _width={24} name={'/icons/unit-01.svg'} _height={24} _marginLeft={-28} />

                  <span className="sidebar-mini-hide text-decoration-none mx-1">Units</span>
                </Link>
              </li>

              <li className="mb-2">
                <Link className="bg-light text-decoration-none" to={'/product'} onClick={mainWrapper}>
                  <i className="fa fa-inbox color-text-dark"></i>
                  <span className="sidebar-mini-hide text-decoration-none">Products</span>
                </Link>
              </li>

              <li className="mb-2">
                <Link className="bg-light text-decoration-none" to={'/supplier'} onClick={mainWrapper}>
                  <i className="fa fa-users color-text-dark"></i>
                  <span className="sidebar-mini-hide text-decoration-none">Suppliers</span>
                </Link>
              </li>

              <li className="mb-2">
                <Link className="bg-light text-decoration-none" to={'/consumer'} onClick={mainWrapper}>
                  <i className="fa fa-user color-text-dark"></i>
                  <span className="sidebar-mini-hide text-decoration-none">Consumer</span>
                </Link>
              </li>
              <li className="mb-2">
                <Link className="bg-light text-decoration-none" to={'/materialissuing'} onClick={mainWrapper}>
                  <i className="fa fa-arrow-down color-text-dark "></i>
                  <span className="sidebar-mini-hide text-decoration-none">Material Issuing</span>
                </Link>
              </li>

              <li className="mb-2">
                <Link className="bg-light text-decoration-none" to={'/materialreturning'} onClick={mainWrapper}>
                  <i className="fa fa-arrow-up color-text-dark "></i>
                  <span className="sidebar-mini-hide text-decoration-none">Materials Returning</span>
                </Link>
              </li>

              <li className="mb-2">
                <Link className="bg-light text-decoration-none" to={'/orders'} onClick={mainWrapper}>
                  <i className="fa fa-shopping-cart color-text-dark"></i>
                  <span className="sidebar-mini-hide text-decoration-none">Purchase Order</span>
                </Link>
              </li>

              <li className="mb-2">
                <Link className="bg-light text-decoration-none" to={'/materials'} onClick={mainWrapper}>
                  <Logo _width={22} name={'/icons/paper.svg'} _height={22} _marginLeft={-20} />
                  <span className="sidebar-mini-hide text-decoration-none mx-2">Requested Materials</span>
                </Link>
              </li>

              {
                initialVlaues.isAdmin === true ? (
                  <li className="mb-2">
                    <Link className="bg-light text-decoration-none" to={'/business'} onClick={mainWrapper}>
                      <i className="fa fa-building color-text-dark mx-2"></i>
                      <span className="sidebar-mini-hide text-decoration-none mx-2">Business</span>
                    </Link>
                  </li>) : <></>
              }

              {
                initialVlaues.isAdmin === true ? (
                  <li className="mb-2">
                    <Link className="bg-light text-decoration-none" to={'/requested_products_reports'} onClick={mainWrapper}>
                    <Logo _width={18} name={'/icons/report.svg'} _height={18} _marginLeft={-18} />
                      <span className="sidebar-mini-hide text-decoration-none mx-2">Purchased Reports</span>
                    </Link>
                  </li>) : <></>
              }
              {
                initialVlaues.isAdmin === true ? (
                  <li className="mb-2">
                    <Link className="bg-light text-decoration-none" to={'/ordered_products_reports'} onClick={mainWrapper}>
                    <Logo _width={18} name={'/icons/report.svg'} _height={18} _marginLeft={-18} />
                      <span className="sidebar-mini-hide text-decoration-none mx-2">Consumed Reports</span>
                    </Link>
                  </li>) : <></>
              }


              {
                initialVlaues.isAdmin === true ? (<li className="mb-2">
                  <Link className="bg-light text-decoration-none" to={'/roles'} onClick={mainWrapper}>
                    <Logo _width={15} name={'/icons/role1.png'} _height={15} _marginLeft={-20} />
                    <span className="sidebar-mini-hide text-decoration-none mx-2">Users Privilege</span>
                  </Link>
                </li>) : <></>
              }



              {
                initialVlaues.isAdmin === true ? (<li className="mb-2">
                  <Link className="bg-light text-decoration-none" to={'/settings'} onClick={mainWrapper}>
                    <i className="fa fa-gear color-text-dark"></i>
                    <span className="sidebar-mini-hide text-decoration-none">Settings</span>
                  </Link>
                </li>) : <></>
              }

              <li className="mb-2">
                <Link className="bg-light text-decoration-none" to={'/signin'} onClick={mainWrapper}>
                  <i className="fa fa-sign-out color-text-dark"></i>
                  <span className="sidebar-mini-hide text-decoration-none" onClick={lougOut}>Log out</span>
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </div>
  );
};

export default Sidebar;
